import React, { useRef } from 'react';
import classNames from 'classnames';
import { Translate } from '../../config/TranslationProvider';
import useIntersectionObserver from '../../util/useIntersectionObserver';
import LocationsCard from '../card/LocationsCard';

const FetchMoreButton = ({fetchMore, canFetchMore, isFetchingMore}) => {
    const fetchMoreButtonRef = useRef();

    useIntersectionObserver({
        target: fetchMoreButtonRef,
        onIntersect: fetchMore,
        enabled: canFetchMore,
    });

    if (canFetchMore) {
        return (
            <button
                ref={fetchMoreButtonRef}
                onClick={() => fetchMore()}
                disabled={isFetchingMore}
                className="btn btn-block btn-secondary"
            >
                <Translate value={isFetchingMore ? 'loading_locations' : 'show_more_locations'} />
            </button>
        );
    }

    return null;
};

const LocationsListing = ({type = 'grid12', locationGroups, fetchMore, canFetchMore, isFetchingMore}) => {
    let gridClass = classNames({
        'col-lg-4 col-sm-6': type === 'grid4',
        'col-lg-6 col-sm-6': type === 'grid6',
        'col-lg-12': type === 'grid12',
    });

    let listClass = classNames({
        'atbd_listing_list': type === 'grid12'
    });

    return (
        <>
            <div className="row">
                {locationGroups.map(locations => locations.data.map((location, key) => (
                    <div className={gridClass} key={key}>
                        <div className={listClass}>
                            <LocationsCard location={location} isGrid={type !== 'grid12'} />
                        </div>
                    </div>
                )))}
            </div>

            {/* Enable fetch more button if available */}
            {fetchMore && (
                <FetchMoreButton fetchMore={fetchMore} canFetchMore={canFetchMore} isFetchingMore={isFetchingMore} />
            )}
        </>
    );
};

export default LocationsListing;
